// import {HttpClient} from '@angular/common/http';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import {ExternalOrderProviderStatusNote} from 'src/app/models/ExternalOrderProviderStatusNote';
import Order from 'src/app/models/Order';
import {OrderPool} from 'src/app/models/OrderPool';
import {OrderStatus} from 'src/app/models/OrderStatus';
import {OrderType} from 'src/app/models/OrderType';
import {PreorderType} from 'src/app/models/PreorderType';
import {TerminalorderType} from 'src/app/models/TerminalorderType';
import {Venue} from 'src/app/models/Venue';
import {OrderService, STATUS_CHANGE} from 'src/app/services/order.service';
import {
	checkIfManualAcceptedView,
	isUber,
	isWolt
} from '../manager-utils/manager-utils';

@Component({
	selector: 'app-order-item-status-section',
	templateUrl: './order-item-status-section.component.html',
	styleUrls: ['./order-item-status-section.component.scss']
})
export class OrderItemStatusSectionComponent {
	public order: Order;
	public orderPool: OrderPool;
	public orderStatusEnum = OrderStatus;
	public ExternalOrderProviderStatusNote = ExternalOrderProviderStatusNote;
	public type: PreorderType | TerminalorderType | null;
	public orderPoolTotalProducts: number;
	public pt = PreorderType;
	public additionalInfoShow = false;
	public ot = OrderType;
	public checkIfManualAcceptedView = checkIfManualAcceptedView;

	@Input() venue: Venue | null;
	@Input() updateStatusLoading: boolean | null;
	@Input() set orderValue(value: Order | OrderPool) {
		if (value) {
			if (this.checkIfOrder(value)) {
				this.order = value;
				this.type = this.orderSevice.getOrderPreorderOrTerminalType(value);
			}
			if (this.checkIfOrderPool(value)) {
				this.orderPool = value;
				console.log(
					this.orderPool.orders.reduce((acc, redd) => {
						console.log(acc, redd.orderedArticles.length);
						return (
							acc +
							redd.orderedArticles
								.map(it => it.quantity)
								.reduce((a, b) => a + b, 0)
						);
					}, 0)
				);
				this.orderPoolTotalProducts = this.orderPool.orders.reduce(
					(acc, redd) => {
						return (
							acc +
							redd.orderedArticles
								.map(it => it.quantity)
								.reduce((a, b) => a + b, 0)
						);
					},
					0
				);
				console.log('orderPoolTotalProducts', this.orderPoolTotalProducts);
			}
		}
	}
	@Output() emitSelectOrderToShow = new EventEmitter<{
		orderId: string;
	}>();
	@Output() sendOrderStatusChange = new EventEmitter<{
		order: Order;
		status: STATUS_CHANGE;
	}>();
	@Output() sendStatusOrderPool = new EventEmitter<{
		orderPool: OrderPool;
		status: STATUS_CHANGE;
	}>();
	statusChangeENUM = STATUS_CHANGE;
	constructor(
		private orderSevice: OrderService,
		private translate: TranslateService // private httpClient: HttpClient
	) {}
	updateStatus(order: Order, status: STATUS_CHANGE) {
		this.sendOrderStatusChange.emit({order, status});
	}
	updateStatusPool(orderPool: OrderPool, status: STATUS_CHANGE) {
		console.log('STATUS POOOl', {orderPool, status});
		this.sendStatusOrderPool.emit({orderPool, status});
	}
	checkIfOrder(value: Order | OrderPool): value is Order {
		return value && (value as Order)?.orderedArticles != undefined;
	}
	checkIfOrderPool(value: Order | OrderPool): value is OrderPool {
		return value && (value as OrderPool)?.dndCompany != undefined;
	}
	selectOrderToShow(order: Order) {
		this.emitSelectOrderToShow.emit({
			orderId: order._id || ''
		});
	}
	formatTime(time: string | undefined) {
		if (!time) {
			return '';
		}
		return moment(time).format('HH:mm DD/MM');
	}
	toggleAdditionalInfo() {
		this.additionalInfoShow = !this.additionalInfoShow;
	}

	getStatus(): string {
		if (!this.order) {
			return '';
		}

		if (
			this.order.ExternalOrderProviderStatusNote ===
			ExternalOrderProviderStatusNote.CANCELLED
		) {
			return this.translate.instant(
				'status.' + ExternalOrderProviderStatusNote.CANCELLED
			);
		}

		if (
			this.venue &&
			checkIfManualAcceptedView(this.order, this.venue) &&
			!this.order.externalOrderAcceptedBy
		) {
			return this.translate.instant(
				'status.' + OrderStatus.AWAITING_CONFIRMATION
			);
		}

		return this.translate.instant('status.' + this.order.status);
	}

	getExternalProviderColor(order: Order, venue: Venue | null): string | null {
		if (!order || !venue) return null;
		if (!checkIfManualAcceptedView(order, venue)) {
			return null;
		}

		if (isWolt(order)) {
			return '#00323C';
		}

		if (isUber(order)) {
			return '#003A0F';
		}

		return null;
	}
}
